// The files in the platform agent's message box (D6, docs/platform-agent/contracts.md §8). The label, placeholder
// and hint stay in PlatformAgentConversation's `composer`.
export default {
  drop: 'Slip filer her: PDF, fotos, Excel, CSV eller Word',
  waiting: 'Afsendelsen venter, til filerne er uploadet.',
  // A message sent while New chat is starting waits for the new chat (QA90).
  starting: 'Et øjeblik: den nye chat starter, og din besked sendes derhen.',
  // A message that waits for the person to deal with a file that can't go with it (QA121).
  blocked: {
    refused: 'Fjern filen, der ikke kan sendes, og send derefter din besked.',
    failed: 'Prøv at uploade filen igen eller fjern den, og send derefter din besked.',
  },
  // A PDF's pages on its tile (B37): "PDF · 1.2 MB · 4 pages".
  pages_one: '{{count}} side',
  pages_other: '{{count}} sider',
  problems: {
    type: 'Denne filtype kan ikke sendes. Send en PDF, et foto (JPG, PNG eller HEIC) eller en Excel-, CSV- eller Word-fil.',
    size: 'Over 20 MB. En fil må højst være på 20 MB.',
    empty: 'Denne fil er tom.',
    count: 'Op til 10 filer pr. besked.',
    upload: 'Uploadet blev afbrudt. Prøv igen.',
  },
};
